import '~/setup/sentry';
import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { env } from './env';
import TabVisibilitySensor from './features/base/components/TabVisibilitySensor';
import { handleLoginRedirect } from './features/login/redirect';
import { main } from './setup';
import IntlContainer from '~/features/base/components/IntlContainer';
import MainContainer from '~/features/base/components/MainContainer';
import { NoMatch } from '~/features/base/components/NoMatch';
import { history, store } from '~/setup/store';

const renderApplication = () => {
    createRoot(document.getElementById('root')).render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <TabVisibilitySensor />
                <IntlContainer>
                    <Switch>
                        <Route path='/error' component={NoMatch} />
                        <Route path='/' component={MainContainer} />
                        <Route component={NoMatch} />
                    </Switch>
                </IntlContainer>
            </ConnectedRouter>
        </Provider>,
    );
};

if (window.location.href.startsWith(env.runtimeConfig.login.redirectUri)) {
    handleLoginRedirect();
} else {
    main(renderApplication);
}
